import { osVersion } from 'expo-device';
import { IS_ANDROID } from './platform';

/**
 * High crash rate on Android 12 due to native driver issues with certain libraries.
 **/
export const allowNativeDriver = () => {
  return !(IS_ANDROID && osVersion === '12');
};
